import Vue from 'vue'
import DataDict from '@/utils/dict'
import { getDicts as getDicts } from '@/assets/js/api'

function install() {
  Vue.use(DataDict, {
    metas: {
      '*': {
        labelField: 'label',
        valueField: 'value',
        request(dictMeta) {
          return getDicts(dictMeta.type).then(
           
            res => res)
        },
      },
    },
  })
}

export default {
  install,
}  


// WEBPACK FOOTER //
// ./src/components/DictData/index.js